import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Row, Col, Layout } from 'antd'
import logoIn from '../../assets/images/in.png'
// import logoCorfo from '../../assets/images/logo-corfo.png'
import { VERSION } from '../../utils'
const { Footer } = Layout
export class BigFooter extends Component {
  render() {
    const { intl } = this.props
    return (
      <div className='footer'>
        <Footer className='footer-info' >
          <Row type="flex" justify="space-between" align="middle">
            <Col xs={12} sm={8} md={8} lg={8} xl={8} className='footer-contact' >
              <div style={{ color: '#3FA9F5' }} className='contact'>{intl.formatMessage({ id: "contact" })}</div>
              <div style={{ color: '#939393' }} className='contact'>Hola@bunkey.tv</div>
              <div style={{ color: '#939393' }} className='contact'>iF,  Dr Carlos Charlin 101, Providencia</div>
              <div style={{ color: '#939393' }} className='contact'>Región Metropolitana, Chile</div>
            </Col>
            <Col xs={12} sm={8} md={8} lg={8} xl={8} className='footer-corfo'>
              {/* <img src={logoCorfo} alt="corfo" className='corfo' /> */}
            </Col>
            <Col xs={24} sm={8} md={8} lg={8} xl={8} className='footer-linkedin'>
              <div className='linkedin-title'>
                <div>{intl.formatMessage({ id: "follow" })}</div>
                <a href="https://www.youtube.com/channel/UCUeN-p0BJfYPLn986C0s-2A" alt="Bunkey" target='blank' >
                  <img alt="Bunkey" src="/images/icons/youtube-logo-bunkey.png" className="linkedin-logo tour-youtube" style={{ width: '76px' }} />
                </a>
                <a href="https://www.linkedin.com/company/bunkey/" alt="Bunkey" style={{ marginLeft: '3%' }}>
                  <img src={logoIn} alt="linkedin" className='linkedin-logo' />
                </a>
              </div>
            </Col>
          </Row>
        </Footer>
        <Footer className='footer-copyright' >
          <Row>
            <Col className='copyright' style={{ textAlign: 'center' }}>
              Copyright @ Bunkey 2022 all rights reserved
            </Col>
          </Row>
          <Row>
            <Col style={{ textAlign: 'center' }}>
              <span>v{VERSION}</span>
            </Col>
          </Row>
        </Footer>
      </div >
    )
  }
}

const mapStateToProps = state => {
  return {

  }
}

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(BigFooter)))